import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../../config/axiosApi/axiosApi";
import APIs from "../../Constants/apis";
import showErrorToast, {
  showSuccessToast,
} from "../../components/CustomComponents/toast/toast";
import GridSectionLoader from "../../components/CustomComponents/preLoad/gridSectionLoader";

function SmsTopUpComplete() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Confirming SMS payment...");

  useEffect(() => {
    let cancelled = false;

    const finalize = async () => {
      const session =
        searchParams.get("session") || searchParams.get("sessionId");
      if (!session) {
        showErrorToast("Missing checkout session");
        navigate("/messaging/smsTopUps", { replace: true });
        return;
      }

      try {
        const response = await axiosInstance.post(
          APIs.POST_FINALIZE_INVOICE_DOJO_CHECKOUT,
          null,
          { params: { sessionId: session } }
        );

        if (cancelled) return;

        if (response.data?.status && response.data.data?.paid) {
          showSuccessToast(
            response.data.message ||
              "Payment successful. SMS credits have been added."
          );
          navigate("/messaging/smsTopUps", { replace: true });
          return;
        }

        const statusRes = await axiosInstance.get(
          APIs.GET_INVOICE_DOJO_CHECKOUT_STATUS,
          { params: { sessionId: session } }
        );

        if (cancelled) return;

        if (statusRes.data?.status && statusRes.data.data?.paid) {
          showSuccessToast("Payment successful. SMS credits have been added.");
          navigate("/messaging/smsTopUps", { replace: true });
          return;
        }

        setMessage(
          statusRes.data?.message ||
            response.data?.message ||
            "Payment is still processing. Check balance shortly."
        );
        showErrorToast(
          statusRes.data?.message ||
            response.data?.message ||
            "Payment not completed yet"
        );
        setTimeout(() => {
          navigate("/messaging/smsTopUps", { replace: true });
        }, 2500);
      } catch (err) {
        if (cancelled) return;
        console.error(err);
        showErrorToast(
          err.response?.data?.message || "Failed to confirm SMS payment"
        );
        navigate("/messaging/smsTopUps", { replace: true });
      }
    };

    finalize();
    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  return (
    <div className="content">
      <div className="container-fluid py-5">
        <GridSectionLoader loading={true} minHeight="160px">
          <div className="text-center">{message}</div>
        </GridSectionLoader>
      </div>
    </div>
  );
}

export default SmsTopUpComplete;
